import { TourVariationViewModel } from '@api/models/TourVariationViewModel';
import { Guest } from '@components/ui/guest-box/guest-box-tab/GuestBox';

export enum ACTIONS {
  SET_BASKET_ID,
  SET_PACKAGE_PROMOTION,
  REMOVE_ROOM,
  REMOVE_PACKAGE_PROMOTION,
}

type TourVariationViewModelWithMeta<Meta = unknown> = TourVariationViewModel & {
  meta?: Meta;
};
export type Action =
  | { type: ACTIONS.SET_BASKET_ID; payload: string }
  | {
      type: ACTIONS.SET_PACKAGE_PROMOTION;
      payload: {
        packageId: number;
        promotion: TourVariationViewModelWithMeta;
        roomNumber: number;
      };
    }
  | {
      type: ACTIONS.REMOVE_ROOM;
      payload: {
        packageId: number;
        roomNumber: number;
      };
    }
  | {
      type: ACTIONS.REMOVE_PACKAGE_PROMOTION;
      payload: {
        packageId: number;
        variationId: string;
      };
    };

export interface TourDetailState {
  basketId?: string;
  resource?: 'Tur' | 'Gemi';
  selectedPromotions: Partial<Record<number, TourVariationViewModelWithMeta[]>>;
}

export interface SelectedVariations {
  id: number;
  title?: string;
  price?: number;
  currency?: string;
  guests: Guest[];
  day?: number;
  nightCount?: number;
  packageDetailId?: number;
  companyCommissionAmount?: number;
  variationId: string;
  roomId?: string;
  variationIndex?: number;
}
